import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.state';

export const selectUiState = createFeatureSelector<UiState>('uiState');

export const selectUiLoading = createSelector(
  selectUiState,
  (state: UiState): boolean => state.loading
);
